<template>
  <div class="divContainer">
    <div v-if="loading" v-loading="loading" class="fullContainer"></div>
    <div v-else class="container">
      <main class="main">
        <el-form
          label-position="top"
          size="small"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          disabled
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-card class="card">
                <div slot="header">
                  <strong style="font-size: 14px">壁纸基本信息</strong>
                </div>
                <div>
                  <el-form-item label="壁纸名称" prop="name">
                    <el-input
                      v-model="ruleForm.name"
                      placeholder="请输入壁纸名称"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Key" prop="key">
                    <el-input
                      v-model="ruleForm.key"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="壁纸类型" prop="type">
                    <el-input
                      v-model="ruleForm.type"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="设计师" prop="designer">
                    <el-select
                      v-model="ruleForm.designer"
                      placeholder="请选择设计师"
                      style="width: 300px"
                    >
                      <el-option
                        v-for="item in designerOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Shader" v-if="shader">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="shader"
                      placement="top"
                    >
                      <div class="shaderTitle">{{ shader }}</div>
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item label="创建时间" prop="createTime">
                    <el-input
                      v-model="ruleForm.createTime"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-card>
              <el-card class="card">
                <div slot="header">
                  <strong style="font-size: 14px">关联解锁组</strong>
                </div>
                <div>
                  <el-form-item label="默认解锁组" prop="defaultUnlockType">
                    <el-select
                      v-model="ruleForm.defaultUnlockType"
                      placeholder="请选择默认解锁组"
                    >
                      <el-option
                        v-for="item in defaultUnlockOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="数据集解锁组(选填)">
                    <div
                      v-for="(item, index) in ruleForm.data_unlock_type_list"
                      :key="index"
                      style="display: flex; margin-bottom: 5px"
                    >
                      <el-select
                        v-model="item.lockGroupName"
                        placeholder="请选择解锁组"
                      >
                        <el-option
                          v-for="item in defaultUnlockOptions"
                          :key="item.key"
                          :label="item.name"
                          :value="item.name"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="item.dataSetName"
                        placeholder="请选择数据集"
                        style="margin: 0 10px"
                      >
                        <el-option
                          v-for="item in dataOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card>
                <div slot="header">
                  <strong
                    style="font-size: 14px; cursor: pointer"
                    :class="dataResouceFlag ? 'dataActive' : ''"
                    @click="changeDataResouce(true)"
                    >预览</strong
                  >
                  <strong style="margin: 0 10px">/</strong>
                  <strong
                    style="font-size: 14px; cursor: pointer"
                    :class="dataResouceFlag ? '' : 'dataActive'"
                    @click="changeDataResouce(false)"
                    >预览webp</strong
                  >
                </div>
                <div class="reviewDiv">
                  <div class="contentImg">
                    <video
                      autoplay
                      style="max-width: 80%; max-height: 80%"
                      v-if="
                        ruleForm.backgroundUrl && websockDataKey === 'video'
                      "
                      :src="ruleForm.backgroundUrl"
                      controls
                      muted
                    ></video>

                    <div
                      v-else-if="
                        this.ruleForm.backgroundUrl &&
                        this.websockDataKey === 'animation'
                      "
                    >
                      <lottie :options="options"> </lottie>
                    </div>

                    <img
                      v-else-if="this.ruleForm.backgroundUrl"
                      v-lazy="this.ruleForm.backgroundUrl"
                      :key="this.websockDataKey"
                      alt="预览图"
                      :style="
                        this.websockDataKey === 'microThumbShow'
                          ? 'width:27px'
                          : ''
                      "
                    />
                    <el-empty
                      description="预览页面为空"
                      :image-size="200"
                      v-else
                    ></el-empty>
                  </div>
                  <div
                    v-if="
                      ruleForm.type === '静态壁纸资源' ||
                      ruleForm.type === '联系人海报资源' ||
                      ruleForm.type === 'TV屏保'
                    "
                  >
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl ===
                              item['content']['imageUrl']
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item['content']['imageUrl'],
                                'imageUrl'
                              )
                            "
                            >主静态图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.thumbUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.thumbUrl, 'thumbUrl')"
                            >缩略图</el-tag
                          >
                          <el-tag type="warning">
                            <a
                              class="alinkStyle"
                              :href="jsonUrl(activeName)"
                              target="_blank"
                            >
                              json数据
                            </a>
                          </el-tag>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.microThumbShow
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                            "
                            >微缩图</el-tag
                          >
                        </div>
                        <div v-else>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.staticImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.staticImage, 'imageUrl')"
                            >预览图</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '视频壁纸资源'">
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.content.imageUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                            "
                            >主静态图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.thumbUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.thumbUrl, 'thumbUrl')"
                            >缩略图</el-tag
                          >
                          <el-tag type="warning">
                            <a
                              class="alinkStyle"
                              :href="jsonUrl(activeName)"
                              target="_blank"
                            >
                              json数据
                            </a>
                          </el-tag>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.microThumbShow
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                            "
                            >微缩图</el-tag
                          >

                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.content.videoUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(item.content.videoUrl, 'video')
                            "
                            >视频资源</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                        </div>
                        <div v-else>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.staticImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.staticImage, 'imageUrl')"
                            >预览图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.videoImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.videoImage, 'video')"
                            >视频资源</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '4D Parallax壁纸资源'">
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.content.imageUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                            "
                            >主静态图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.thumbUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.thumbUrl, 'thumbUrl')"
                            >缩略图</el-tag
                          >
                          <el-tag type="warning">
                            <a
                              class="alinkStyle"
                              :href="jsonUrl(activeName)"
                              target="_blank"
                            >
                              json数据
                            </a>
                          </el-tag>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.microThumbShow
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                            "
                            >微缩图</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.content.parallaxImage
                              .layers"
                            :key="val.index"
                            :type="
                              ruleForm.backgroundUrl === val.url
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val.url, 'layer4D', index)"
                            >layer{{ index + 1 }}</el-tag
                          >
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.staticImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.staticImage, 'imageUrl')"
                            >预览图</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.layers"
                            :key="val"
                            :type="
                              ruleForm.backgroundUrl === val
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val, 'layer4D', index)"
                            >layer{{ index + 1 }}</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '重力壁纸资源'">
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.content.imageUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                            "
                            >主静态图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.thumbUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.thumbUrl, 'thumbUrl')"
                            >缩略图</el-tag
                          >
                          <el-tag type="warning">
                            <a
                              class="alinkStyle"
                              :href="jsonUrl(activeName)"
                              target="_blank"
                            >
                              json数据
                            </a>
                          </el-tag>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.microThumbShow
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                            "
                            >微缩图</el-tag
                          >

                          <el-tag
                            :type="
                              ruleForm.backgroundUrl ===
                              item.content.gravityImage.bgUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.content.gravityImage.bgUrl,
                                'backgroundImg'
                              )
                            "
                            >背景图</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.content.gravityImage
                              .elements"
                            :key="val.url"
                            :type="
                              ruleForm.backgroundUrl === val.url
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val.url, 'element', index)"
                            >element{{ index + 1 }}</el-tag
                          >
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.staticImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.staticImage, 'imageUrl')"
                            >预览图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.backgroundImage
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.backgroundImage,
                                'backgroundImg'
                              )
                            "
                            >背景图</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.layers"
                            :key="val"
                            :type="
                              ruleForm.backgroundUrl === val
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val, 'element', index)"
                            >element{{ index + 1 }}</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '动画壁纸资源'">
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.content.imageUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                            "
                            >主静态图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.thumbUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.thumbUrl, 'thumbUrl')"
                            >缩略图</el-tag
                          >
                          <el-tag type="warning">
                            <a
                              class="alinkStyle"
                              :href="jsonUrl(activeName)"
                              target="_blank"
                            >
                              json数据
                            </a>
                          </el-tag>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.microThumbShow
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                            "
                            >微缩图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.wallpaper
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.wallpaper, 'animation')"
                            >动画</el-tag
                          >

                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 2,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >wallpaperZip</el-tag
                          >

                          <el-tag
                            v-for="(val, index) in item.images"
                            :key="val"
                            :type="
                              ruleForm.backgroundUrl === val
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val, 'images', index)"
                            >images{{ index + 1 }}</el-tag
                          >
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.staticImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.staticImage, 'imageUrl')"
                            >预览图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.wallpaper
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.wallpaper, 'animation')"
                            >动画</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 1,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >资源下载</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                                name: activeName,
                                resourceType: 2,
                                isWebp: dataResouceFlag ? 0 : 1,
                              })
                            "
                            >wallpaperZip</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.layers"
                            :key="val"
                            :type="
                              ruleForm.backgroundUrl === val
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val, 'images', index)"
                            >images{{ index + 1 }}</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '壁纸合集资源'">
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.content.imageUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                            "
                            >主静态图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.thumbUrl
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.thumbUrl, 'thumbUrl')"
                            >缩略图</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.microThumbShow
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                            "
                            >微缩图</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.content.image_list"
                            :key="val"
                            :type="
                              ruleForm.backgroundUrl === val
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val, 'collect', index)"
                            >合集图片:{{ index + 1 }}</el-tag
                          >
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl === item.staticImage
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(item.staticImage, 'imageUrl')"
                            >预览图</el-tag
                          >
                          <el-tag
                            v-for="(val, index) in item.image_list"
                            :key="val"
                            :type="
                              ruleForm.backgroundUrl === val
                                ? 'success'
                                : 'info'
                            "
                            @click="setContentImg(val, 'collect', index)"
                            >合集图片:{{ index + 1 }}</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === 'OS26景深壁纸资源'">
                    <el-tabs
                      v-model="activeName"
                      @tab-click="handleClick"
                      stretch
                    >
                      <el-tab-pane
                        :label="item.name"
                        v-for="(item, index) in websockData"
                        :key="index"
                        :name="item.name"
                      >
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.iphone_preview
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.content.wallpaperConfig.iphone_preview,
                                'OS26景深壁纸资源'
                              )
                            "
                            >iphone_preview
                          </el-tag>
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.ipad_preview
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.content.wallpaperConfig.ipad_preview,
                                'OS26景深壁纸资源'
                              )
                            "
                            >ipad_preview</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.highlight
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.content.wallpaperConfig.highlight,
                                'OS26景深壁纸资源'
                              )
                            "
                            >highlight</el-tag
                          >
                          <el-tag
                            :type="
                              ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.original
                                ? 'success'
                                : 'info'
                            "
                            @click="
                              setContentImg(
                                item.content.wallpaperConfig.original,
                                'OS26景深壁纸资源'
                              )
                            "
                            >original</el-tag
                          >
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag
                            type="warning"
                            v-for="item in item.image_list"
                            @click="downloadContent(item)"
                            >{{
                              item.substring(item.lastIndexOf("_") + 1)
                            }}</el-tag
                          >
                          <el-tag
                            type="warning"
                            @click="
                              downloadZip({
                                type: 0,
                                id: $route.params.id,
                              })
                            "
                            >zip下载</el-tag
                          >
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else>
                    <el-tag
                      style="margin-bottom: 10px"
                      type="warning"
                      v-for="item in websockData[websockData.length - 1]
                        .image_list"
                      @click="downloadContent(item)"
                      >{{ item.substring(item.lastIndexOf("_") + 1) }}</el-tag
                    >
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-card class="card">
            <div slot="header">
              <strong style="font-size: 14px">关联分类</strong>
            </div>
            <div>
              <div style="font-size: 12px; margin-bottom: 20px">
                已关联分类<span style="color: gray">（选填）</span>
              </div>
              <div>
                <el-tag
                  :key="index"
                  v-for="(tag, index) in ruleForm.dynamicTags"
                  closable
                  :disable-transitions="false"
                >
                  {{ tag.name }}
                </el-tag>
                <el-button size="mini">+ New Tag</el-button>
              </div>
            </div>
          </el-card>

          <el-card class="card">
            <div slot="header">
              <strong style="font-size: 14px">关联Tag</strong>
            </div>
            <div>
              <div style="font-size: 12px; margin-bottom: 20px">
                已关联Tag<span style="color: gray">（选填）</span>
              </div>
              <div>
                <el-tag
                  :key="index"
                  v-for="(tag, index) in ruleForm.tagVOList"
                  closable
                  :disable-transitions="false"
                >
                  {{ tag.name }}
                </el-tag>
                <el-button size="mini">+ New Tag</el-button>
              </div>
            </div>
          </el-card>
          <filter-resource-card
            :country="ruleForm.country"
            :appVersion="ruleForm.appVersion"
            :dataOptions="dataOptions"
            :androidBeginVersion.sync="ruleForm.androidBeginVersion"
            :androidOverVersion.sync="ruleForm.androidOverVersion"
            :androidNeglectVersion.sync="ruleForm.androidNeglectVersion"
            :iosBeginVersion.sync="ruleForm.iosBeginVersion"
            :iosOverVersion.sync="ruleForm.iosOverVersion"
            :iosNeglectVersion.sync="ruleForm.iosNeglectVersion"
            :disabled="true"
          ></filter-resource-card>
          <other-card :remarks.sync="ruleForm.comment"></other-card>
        </el-form>
      </main>
      <footer class="bottomContainer">
        <div>
          <el-button size="small" type="info" @click="deleteData" v-check-role
            >删除</el-button
          >
          <el-button
            type="success"
            size="small"
            v-if="ruleForm.status === 0"
            @click="liveOrOff"
            v-check-role
            >上线</el-button
          >
          <el-button
            type="danger"
            size="small"
            v-else
            @click="liveOrOff"
            v-check-role
            >下线</el-button
          >
        </div>
        <div>
          <el-button size="small" style="margin-right: 10px" @click="goBack"
            >取消</el-button
          >
          <router-link
            :to="{
              path: '/resource/wallpaper/edit/' + this.$route.params.id,
            }"
          >
            <el-button type="primary" size="small" v-check-role>编辑</el-button>
          </router-link>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  downloadResourceZip,
  getAllDesignerOptionCreate,
} from "../../../api/comment";
import { getAllDataList } from "../../../api/classifyManage";
import { getLockList } from "../../../api/unlockMode";
import index from "../../../components/lottie/index.vue";
import {
  deleteWallpaperById,
  onOrOff,
  getWallpaperById,
} from "../../../api/wallpaperManage";
import filterResourceCard from "../../../components/filterResourceCard.vue";
import otherCard from "../../../components/otherCard.vue";
export default {
  name: "createOrEdit",
  data() {
    return {
      wallpaperWebpUrlList: [],
      wallpaperUrlList: [],
      ruleForm: {
        name: "",
        key: "",
        type: "",
        designer: "",
        country: {
          isExclude: false,
          countries: [],
        },

        androidBeginVersion: "",
        androidOverVersion: "",
        androidNeglectVersion: "",
        iosBeginVersion: "",
        iosOverVersion: "",
        iosNeglectVersion: "",

        appVersion: [
          {
            start: "",
            end: "",
            skip: "",
            dataSetId: "",
          },
        ],
        comment: "",
        backgroundUrl: "",
        backgroundName: "",
        id: "",
        defaultUnlockType: "",
        data_unlock_type_list: [
          {
            lockGroupName: "",
            dataSetName: "",
          },
        ],
        dynamicTags: [],
        tagVOList: [],
      },
      rules: {
        name: [
          { required: true, message: "壁纸名称不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "壁纸类型不能为空", trigger: "change" },
        ],
        designer: [
          { required: true, message: "设计师不能为空", trigger: "change" },
        ],
        backgroundUrl: [
          { required: true, message: "资源包不能为空", trigger: "change" },
        ],
        defaultUnlockType: [
          {
            required: true,
            message: "默认解锁方式不能为空",
            trigger: "change",
          },
        ],
      },
      loading: false,
      wallpaperTypeOptions: [],
      designerOptions: [],
      dataOptions: [],
      defaultUnlockOptions: [],
      websockData: [],
      activeName: "",
      websockDataKey: "",
      websockDataIndex: "",
      dataResouceFlag: true,
      options: {
        animationData: "",
        autoplay: true,
        loop: true,
      },
      shader: "",
    };
  },
  created() {
    //获取所有的数据集
    this.getAllData();
    //获取所有的解锁方式
    this.getAllUnlock();
    //获取所有的设计师
    this.getAllDesigner();
    //请求编辑信息
    this.getRuleForm();
  },
  computed: {
    jsonUrl() {
      return function (activeName) {
        let width = activeName.split("*")[0];
        let height = activeName.split("*")[1];
        let isWebp = this.dataResouceFlag ? 1 : 2;
        return `${window.location.protocol}//${window.location.host}/v1/api/wallpaper/resource/${this.ruleForm.key}/operation?source_height=${height}&source_width=${width}&pictureFormat=${isWebp}`;
      };
    },
  },
  components: {
    lottie: index,
    filterResourceCard,
    otherCard,
  },
  methods: {
    //请求编译信息
    getRuleForm() {
      this.loading = true;
      getWallpaperById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.shader = res.data.shader;
            this.ruleForm.name = res.data.wallpaperName;
            this.ruleForm.key = res.data.key;
            this.ruleForm.type = res.data.wallpaperType;
            this.ruleForm.country = res.data.countryList;
            this.ruleForm.createTime = res.data.createTime;
            this.ruleForm.defaultUnlockType = res.data.defaultLockGroupName;
            this.ruleForm.designer = res.data.authorId;

            this.ruleForm.dynamicTags = res.data.categoryList;
            this.ruleForm.tagVOList = res.data.tagVOList;
            if (res.data.wallpaperLockGroupVOList.length > 0) {
              this.ruleForm.data_unlock_type_list =
                res.data.wallpaperLockGroupVOList;
            }

            if (res.data.wallpaperAppVersionList.length > 0) {
              this.ruleForm.appVersion = this.getAppVersion(
                res.data.wallpaperAppVersionList
              );
            }

            this.ruleForm.comment = res.data.comment;
            this.ruleForm.status = res.data.onOrOff;

            this.ruleForm.id = res.data.id;

            this.ruleForm.androidBeginVersion = res.data.androidBeginVersion;
            this.ruleForm.androidOverVersion = res.data.androidOverVersion;
            if (res.data.androidNeglectVersion) {
              this.ruleForm.androidNeglectVersion =
                res.data.androidNeglectVersion.join(",");
            }

            this.ruleForm.iosBeginVersion = res.data.iosBeginVersion;
            this.ruleForm.iosOverVersion = res.data.iosOverVersion;
            if (res.data.iosNeglectVersion) {
              this.ruleForm.iosNeglectVersion =
                res.data.iosNeglectVersion.join(",");
            }
            this.wallpaperWebpUrlList = res.data.wallpaperWebpUrlList;
            this.wallpaperUrlList = res.data.wallpaperUrlList;
            this.ruleForm.backgroundUrl =
              res.data.wallpaperUrlList[0].content.imageUrl;
            this.websockData = res.data.wallpaperUrlList;
            this.activeName = res.data.wallpaperUrlList[0].name;
            this.websockDataKey = "imageUrl";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAppVersion(data) {
      data.forEach((element) => {
        element.skip = element.skip.join(",");
      });
      return data;
    },

    //获取所有的数据集
    getAllData() {
      getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data;
        }
      });
    },
    //获取搜有的解锁方式
    getAllUnlock() {
      getLockList(
        { pageNum: "", pageSize: "", name: "", lockType: "" },
        0
      ).then((res) => {
        if (res.success) {
          this.defaultUnlockOptions = res.data;
        }
      });
    },
    //获取所有的设计师
    getAllDesigner() {
      getAllDesignerOptionCreate().then((res) => {
        this.designerOptions = res.data;
      });
    },
    //删除分类
    deleteData() {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteWallpaperById({ id: this.$route.params.id }).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.$router.push("/resource/wallpaper/list");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            showClose: true,
            duration: 5000,
          });
        });
    },
    //上线或下线
    liveOrOff() {
      this.$confirm(
        `是否确认将状态改成：${this.ruleForm.status === 0 ? " 上线" : " 下线"}`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          //切换上线下线接口
          onOrOff({ id: this.$route.params.id }).then((res) => {
            if (res.errCode === "300" && res.success === false) {
              this.$confirm(res.errMessage + "，是否跳转到设计师页面", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.$router.push(
                  "/resource/designer/info/" + this.ruleForm.designer
                );
              });
              return;
            }

            if (res.success) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.$router.push("/resource/wallpaper/list");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    handleClick(tab, event) {
      if (!this.websockDataKey) {
        this.websockDataKey = "imageUrl";
      }
      this.websockData.forEach((e) => {
        if (e.name === this.activeName && e.staticImage) {
          if (this.websockDataKey === "layer4D") {
            this.ruleForm.backgroundUrl = e.layers[this.websockDataIndex];
          } else if (this.websockDataKey === "backgroundImg") {
            this.ruleForm.backgroundUrl = e.backgroundImage;
          } else if (this.websockDataKey === "video") {
            this.ruleForm.backgroundUrl = e.videoImage;
          } else if (this.websockDataKey === "element") {
            this.ruleForm.backgroundUrl = e.layers[this.websockDataIndex];
          } else if (this.websockDataKey === "images") {
            this.ruleForm.backgroundUrl = e.layers[this.websockDataIndex];
          } else if (this.websockDataKey === "animation") {
            this.ruleForm.backgroundUrl = e.wallpaper;
            this.options.animationData = e.wallpaper;
          } else if (this.websockDataKey === "collect") {
            this.ruleForm.backgroundUrl = e.image_list[this.websockDataIndex];
          } else {
            this.websockDataKey = "imageUrl";
            this.ruleForm.backgroundUrl = e.staticImage;
          }
        } else if (e.name === this.activeName && !e.staticImage) {
          if (this.websockDataKey === "imageUrl" && this.websockDataKey) {
            this.ruleForm.backgroundUrl = e.content.imageUrl;
          } else {
            if (this.websockDataKey === "layer4D") {
              this.ruleForm.backgroundUrl =
                e.content.parallaxImage.layers[this.websockDataIndex].url;
            } else if (this.websockDataKey === "backgroundImg") {
              this.ruleForm.backgroundUrl = e.content.gravityImage.bgUrl;
            } else if (this.websockDataKey === "video") {
              this.ruleForm.backgroundUrl = e.content.videoUrl;
            } else if (this.websockDataKey === "element") {
              this.ruleForm.backgroundUrl =
                e.content.gravityImage.elements[this.websockDataIndex].url;
            } else if (this.websockDataKey === "images") {
              this.ruleForm.backgroundUrl = e.images[this.websockDataIndex];
            } else if (this.websockDataKey === "animation") {
              this.ruleForm.backgroundUrl = e.wallpaper;
              this.options.animationData = e.wallpaper;
            } else if (this.websockDataKey === "collect") {
              this.ruleForm.backgroundUrl =
                e.content.image_list[this.websockDataIndex];
            } else if (this.websockDataKey === "OS26景深壁纸资源") {
              this.ruleForm.backgroundUrl =
                e.content.wallpaperConfig.iphone_preview;
            } else {
              this.ruleForm.backgroundUrl = e[this.websockDataKey];
            }
          }
        }
      });
    },
    //切换缩缩略图
    setContentImg(src, key, index) {
      this.websockDataKey = key;
      this.ruleForm.backgroundUrl = src;
      if (key === "layer4D") {
        this.websockDataIndex = index;
      } else if (key === "element") {
        this.websockDataIndex = index;
      } else if (key === "images") {
        this.websockDataIndex = index;
      } else if (key === "collect") {
        this.websockDataIndex = index;
      } else if (key === "animation") {
        this.options.animationData = src;
      }
    },
    //改变展示数据源
    changeDataResouce(flag) {
      this.dataResouceFlag = flag;
      if (flag) {
        this.ruleForm.backgroundUrl = this.wallpaperUrlList[0].content.imageUrl;
        this.websockDataKey = "imageUrl";
        this.activeName = "1080*1920";
        this.websockData = this.wallpaperUrlList;
      } else {
        this.ruleForm.backgroundUrl =
          this.wallpaperWebpUrlList[0].content.imageUrl;
        this.websockDataKey = "imageUrl";
        this.activeName = "1080*1920";
        this.websockData = this.wallpaperWebpUrlList;
      }
    },
    goBack() {
      this.$router.back(-1);
    },
    //下载zip资源
    downloadZip(content) {
      let data = new FormData();
      for (let e in content) {
        data.append(e, content[e]);
      }
      var notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "资源整合中...",
        duration: 5000,
      });
      downloadResourceZip(data)
        .then((res) => {
          if (res.success) {
            this.downloadContent(res.data);
          }
        })
        .catch((err) => {
          this.$message({ type: "error", message: err });
        })
        .finally(() => {
          notify.close();
        });
    },
    downloadContent(url) {
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      // eleLink.download = fileName
      eleLink.href = url;
      eleLink.target = "_blank";
      // 受浏览器安全策略的因素，动态创建的元素必须添加到浏览器后才能实施点击
      document.body.appendChild(eleLink);
      // 触发点击
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
  },
};
</script>
<style scoped>
.divContainer {
  height: 100%;
}

.fullContainer {
  width: 100%;
  height: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.main {
  padding: 20px;
}

.card {
  margin-bottom: 20px;
}

.formItemStyle {
  width: 100%;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.smallFont {
  font-size: 12px;
}

.componentItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resourcesComponent {
  margin-bottom: 10px;
}

.resourcesComponent:last-child {
  margin-bottom: 0;
}

.bottomContainer {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px #888;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.addIcon {
  font-size: 20px;
  color: greenyellow;
  cursor: pointer;
}

.deleteIcon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.reviewDiv {
  /* display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; */
}

.el-tag {
  margin-right: 10px;
}

.contentImg {
  display: flex;
  justify-content: center;
  height: 350px;
  align-items: center;
}

.contentImg > img {
  max-width: 80%;
  max-height: 80%;
}

.dataActive {
  color: #569df6;
}

.tagContainer {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.tagContainer::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.alinkStyle {
  text-decoration: none;
}

.shaderTitle {
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  background-color: #46a0fc;
  color: #ffffff;
  border: 1px solid #46a0fc;
}

::v-deep .el-form-item--mini > .el-form-item__label {
  font-size: 12px;
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}

::v-deep .el-tag {
  cursor: pointer;
}
</style>
